import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
import { HeroComponentFallback } from './HeroComponentFallback';
var HeroComponentWrapperInternal = withLazyErrorBoundary(lazy(function () { return import(/* webpackChunkName: "hero" */ './HeroComponent'); }), 'HeroComponent', {
    fallback: HeroComponentFallback,
});
export var HeroComponentWrapper = function () { return React.createElement(HeroComponentWrapperInternal, null); };
//# sourceMappingURL=HeroComponentWrapper.js.map